export default "__VITE_ASSET__DhxgmlH6__"